import { render, staticRenderFns } from "./My_Coin_Dtl.vue?vue&type=template&id=158ec32d&scoped=true"
import script from "./My_Coin_Dtl.vue?vue&type=script&lang=js"
export * from "./My_Coin_Dtl.vue?vue&type=script&lang=js"
import style0 from "./My_Coin_Dtl.vue?vue&type=style&index=0&id=158ec32d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158ec32d",
  null
  
)

export default component.exports